import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import useChooseBaseline from '@/biz/baseline/useChooseBaseline.jsx'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonCompare(props) {
    const chooseBaseline = useChooseBaseline()
    const map = useMapContext()
    const {mapTypeCode, pblType, prjId, sVer: srcSVer} = map.data

    if (! (
        'SA_MAP' === mapTypeCode &&
        'INCREMENT' === pblType
    )) {
        return null
    }

    const onClick = async () => {
        const b = await chooseBaseline({
            defaultSelectFirst: true,
            pblStsCodes: 'ACTIVE',
            //pblType: 'BASELINE',
            prjId,
        })

        if (b) {
            openWindow('/MergeCommonList', {prjId, srcSVer, tarSVer: b.sVer})
        }
    }

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            分支比对
        </MenuButton>
    )
}
